import {useMemo} from 'react';

import {useLocation} from 'react-router-dom';

/**
 *  Isomorphic hook which parsed search params to URLSearchParams object
 *  @returns {URLSearchParams} URLSearchParams object with methods to work with search params
 */
const useSearchParams = (): URLSearchParams => {
    const {search} = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
};

export default useSearchParams;
